import React, { useEffect } from "react";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { Grid, Typography, Hidden } from "@material-ui/core";
import { theme } from "../../theme";
import axios from "axios";
import ReactLoading from "react-loading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import coming from "../../../assets/coming.png";
import cotm from "../../../assets/cotm.jpg";

const Cotm = () => {
  const [loaded, setLoaded] = React.useState(true);
  const [ma, setMa] = React.useState([]);
  const [err, seterr] = React.useState(false);

  const handleYTLink = (link) => () => {
    window.open(link);
  };

  const socialIconStyle = {
    marginTop: 20,
    cursor: "pointer",
    color: "red",
  };

  useEffect(() => {
    setLoaded(true);
    //all articles
    axios
      .get("https://djaura.pythonanywhere.com/cotm/")
      .then((res) => {
        if(res.data.length===0){
          setMa([]);
          setLoaded(false);
          seterr(true);
        }else{
        let items = res.data;
        let newState = [];
        for (let item in items) {
          newState.push({
            id: item,
            description: items[item].ma_desc,
            title: items[item].ma_topic,
            date: items[item].ma_acad_year,
            image: items[item].ma_img,
            link: items[item].ma_link,
          });
          setMa(newState);
          setLoaded(false);
        }
        }
       
      })  
      .catch((e) => {
        console.log('error');
        setMa([]);
        setLoaded(false);
        seterr(true);
      });
  }, []);

  return (
    <MuiThemeProvider theme={theme}>
      <Typography
        variant="h6"
        className="work-description fadeInUp"
        style={{ animationDelay: "0.58s" }}
      >
        <i>
          “Without wonder and insight, acting is just a business. With it, it
          becomes creation.”
        </i>
      </Typography>
      <div className="head fadeInUp" style={{ animationDelay: "0.58s" }}>
        <img src={cotm} alt='cotm' className="head-image" />
      </div>
      <br/>
      <Typography
        variant="h2"
        className="work-description fadeInUp"
        style={{ animationDelay: "0.58s" }}
      >
        What is COTM?
      </Typography>
      <br/>
      <Typography
        variant="h5"
        className=" fadeInUp"
        id='head-description'
        style={{ animationDelay: "0.58s" }}
      >
        It would be wrong if we said that we missed street plays. The performers
        in us were yearning for expression, and we couldn’t stand sitting all
        day at home without doing something about things that need to be
        addressed. So we did the next best thing! While selecting a street play
        topic every year, numerous topics come up and are debated and discussed
        but only one gets a street play dedicated to it. We decided that we take
        our audience on the whole back-end homework of making a street play, by
        taking up topics and understanding them by systematically breaking them
        down. We would break down the prevailing issue in simple terms, explain
        why we need to resolve it, and then provide easy-to-implement solutions
        for the same! We would engage our audience every month with a new
        relevant issue to educate on.
      </Typography>
      <br/>
      <Grid container className="fadeInUp" style={{ animationDelay: "0.7s" }}>
        {loaded ? (
          <ReactLoading type={"bars"} color={"white"} className="loading" />
        ) : err ? (
          <>
          <Typography
        variant="h3" 
        className="head-description fadeInUp"
        style={{ animationDelay: "0.58s",margin:'0 auto' }}
      >
        Want to find out more?
      </Typography>
      <br/>
      <br/>
      <br/>
          <div className="coming">
            <img src={coming} alt='coming' className="coming-image" />
            <p className="coming-text" style={{ animationDelay: "0.58s" }}>
              Coming Soon
            </p>
          </div>
          </>
        ) : (
          ma.map((elm, index) => {
            if (index % 2 === 0) {
              return (
                <Grid
                  id="content"
                  className="content-wrapper extra-padding"
                  item
                  key={index}
                  xs={12}
                  md={12}
                >
                  <Grid
                    container
                    className="fadeInUp"
                    style={{ animationDelay: "0.72s" }}
                  >
                    <Hidden only={["lg", "xl", "md"]}>
                      <Grid item xs={12} sm={12}>
                        <p className="title-sm">
                          {index + 1} &nbsp; {elm.title}
                        </p>
                      </Grid>
                    </Hidden>
                    <Grid
                      item
                      xs={12}
                      sm={10}
                      md={4}
                      style={{ alignSelf: "center" }}
                      id="image-grid"
                    >
                      <div className="img-outer-wrapper">
                        <img src={elm.image} alt={elm.title} className="streetplay-image" />
                      </div>
                    </Grid>
                    <Grid item xs={12} md={8}>
                      <Hidden only={["sm", "xs"]}>
                        <p className="title">
                          {index + 1} &nbsp; {elm.title} &#9679; {elm.date}
                        </p>
                      </Hidden>
                      <Typography
                        variant="h6"
                        className="streetplay-description"
                      >
                        {elm.description}
                      </Typography>
                      <Typography
                        onClick={handleYTLink(elm.link)}
                        variant="h6"
                        style={{
                          cursor: "pointer",
                          fontSize: "1.3rem",
                          textAlign: "left",
                          marginTop: 10,
                          paddingLeft: "4%",
                          color: "white",
                        }}
                      >
                        CHECK IT OUT ON{" "}
                        <FontAwesomeIcon
                          className="icon"
                          style={socialIconStyle}
                          icon={faInstagram}
                        ></FontAwesomeIcon>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              );
            } else {
              return (
                <Grid
                  id="content"
                  className="content-wrapper extra-padding"
                  item
                  key={index}
                  xs={12}
                  md={12}
                >
                  <Grid
                    container
                    className="fadeInUp"
                    style={{ animationDelay: "0.72s" }}
                  >
                    <Hidden only={["lg", "xl", "md"]}>
                      <Grid item xs={12} sm={12}>
                        <p className="title-sm">
                          {index + 1} &nbsp; {elm.title}
                        </p>
                      </Grid>
                    </Hidden>
                    <Hidden only={["sm", "xs"]}>
                      <Grid item xs={12} md={8}>
                        <p className="title">
                          {index + 1} &nbsp; {elm.title} &#9679; {elm.date}
                        </p>
                        <Typography
                          variant="h6"
                          className="streetplay-description"
                        >
                          {elm.description}
                        </Typography>
                        <Typography
                          onClick={handleYTLink(elm.link)}
                          variant="h6"
                          style={{
                            cursor: "pointer",
                            fontSize: "1.3rem",
                            textAlign: "left",
                            marginTop: 10,
                            paddingLeft: "4%",
                            color: "white",
                          }}
                        >
                          CHECK IT OUT ON{" "}
                          <FontAwesomeIcon
                            className="icon"
                            style={socialIconStyle}
                            icon={faYoutube}
                          ></FontAwesomeIcon>
                        </Typography>
                      </Grid>
                    </Hidden>
                    <Grid
                      item
                      xs={12}
                      sm={10}
                      md={4}
                      style={{ alignSelf: "center" }}
                      id="image-grid"
                    >
                      <div className="img-outer-wrapper">
                        <img alt={elm.title} src={elm.image} className="streetplay-image" />
                      </div>
                    </Grid>
                    <Hidden only={["lg", "xl", "md"]}>
                      <Grid item xs={12} md={8}>
                        <Typography
                          variant="h6"
                          className="streetplay-description"
                        >
                          {elm.description}
                        </Typography>
                        <Typography
                          onClick={handleYTLink(elm.link)}
                          variant="h6"
                          style={{
                            cursor: "pointer",
                            fontSize: "1.3rem",
                            textAlign: "left",
                            marginTop: 10,
                            paddingLeft: "4%",
                            color: "white",
                          }}
                        >
                          CHECK IT OUT ON{" "}
                          <FontAwesomeIcon
                            className="icon"
                            style={socialIconStyle}
                            icon={faYoutube}
                          ></FontAwesomeIcon>
                        </Typography>
                      </Grid>
                    </Hidden>
                  </Grid>
                </Grid>
              );
            }
          })
        )}
      </Grid>
    </MuiThemeProvider>
  );
};

export default Cotm;
